import { ExportService } from './export';

export const exportService = new ExportService();
